import React, { useState, useEffect } from 'react';
import { FaUser, FaInfoCircle, FaSave, FaTimes } from 'react-icons/fa';
import axios from 'axios';
import moment from 'moment';
import { LoadingOutlined } from '@ant-design/icons';
import { DatePicker, Spin, message } from 'antd';
import dayjs from 'dayjs';
import { notification } from 'antd';
import VNnum2words from 'vn-num2words';

export default function FrmUpdateContract({ id }) {
    // Define state for all input fields
    const [name, setName] = useState('Họ và tên');
    const [contractCode, setContractCode] = useState('1');
    const [numberCard, setNumberCard] = useState('0xxxxxxxxx');
    const [phone, setPhone] = useState('0xxxxxxxx');
    const [address, setAddress] = useState('Đoán xem');
    const [itemName, setItemName] = useState('Cái gì cắm được không');
    const [totalMoney, setTotalMoney] = useState('0');
    const [rateType, setRateType] = useState(1);
    const [prepaidrate, setPrepaidrate] = useState(false);
    const [loanTime, setLoanTime] = useState(0);
    const [frequency, setFrequency] = useState(0);
    const [rate, setRate] = useState(1.0);
    const [fromDate, setFromDate] = useState('20-09-1999');
    const [note, setNote] = useState('đây là note');
    const [collectorName, setCollectorName] = useState('Trong Hoang (tronghoang2001)');
    const [customerId, setCustomerId] = useState(0);
    const [tooltip, setTooltip] = useState('');
    const [loadingFetch, setLoadingFetch] = useState(true); // State loading
    const [loadingItem, setLoadingItem] = useState(false); // Track loading state for each row
    const whiteSpinnerIcon = <LoadingOutlined style={{ fontSize: 24, color: 'white' }} spin />;
    const [isEdit, setIsEdit] = useState(true);
    const showNotification = (message, type) => {
        notification[type]({
            message: type.charAt(0).toUpperCase() + type.slice(1),
            description: message,
            placement: 'topRight', // Notification position
        });
    };

    const handleChangeLocale = (e) => {
        // Chỉ lấy giá trị số và loại bỏ dấu phẩy
        const value = e.target.value.replace(/\./g, ''); // Xóa dấu phẩy
        setTotalMoney(value);

        if (value) {
            // Cập nhật tooltip với số chuyển đổi thành chữ
            setTooltip(VNnum2words(Number(value)));
        } else {
            setTooltip(''); // Xóa tooltip nếu không có giá trị
        }

    };

    const handleMouseLeave = () => {
        setTooltip('');
    };

    useEffect(() => {
        setLoadingFetch(true)
        const token = localStorage.getItem('token'); // Thay 'your_token_key' bằng key thực tế
        fetch(`${process.env.REACT_APP_API_DB_URL}/loan-credit/${id}`, {
            method: 'GET', // Hoặc 'POST' nếu cần thiết
            headers: {
                'Authorization': `Bearer ${token}`, // Thêm token vào headers
                'Content-Type': 'application/json' // Nếu cần
            }
        })
            .then(response => response.json())
            .then(data => {
                setName(data.NAME)
                setContractCode(data.LOAN_ID);
                setNumberCard(data.NUMBER_CARD);
                setPhone(data.PHONE);
                setAddress(data.ADDRESS);
                setItemName(data.ITEM_NAME);
                setTotalMoney(data.TOTAL_MONEY);
                setRateType(data.RATE_TYPE);
                setLoanTime(data.LOAN_TIME);
                setFrequency(data.FREQUENCY);
                setRate(data.RATE);
                const formattedDate = moment(data.FROM_DATE).format('DD-MM-YYYY');
                setFromDate(formattedDate);
                setNote(data.NOTE);
                setCustomerId(data.CUSTOMER_ID);
                setIsEdit(data.INTEREST_MONEY_RECEIVED !== 0)

             //   console.log(`isEdit ${isEdit}`)
            })
            .catch(error => console.error('Error fetching data:', error))
            .finally(() => setLoadingFetch(false)); // Kết thúc loading
    }, []);


    // Function to handle form submission
    const handleSubmit = async () => {
        const payload = {
            name,
            numberCard,
            phone,
            address,
            itemName,
            totalMoney: Number(totalMoney),
            rateType,
            prepaidrate,
            loanTime: Number(loanTime),
            frequency: Number(frequency),
            rate : Number(rate),
            fromDate: moment(fromDate, 'DD-MM-YYYY').format('YYYY-MM-DD'),
            note,
            collectorName,
            "loanId": id,
            customerId
        };

        try {
            setLoadingItem(true);
            
            // Lấy token từ local storage
            const token = localStorage.getItem('token'); 
            
            // Gửi yêu cầu POST với token trong headers
            const response = await axios.post(`${process.env.REACT_APP_API_DB_URL}/update-loan-credit`, payload, {
                headers: {
                    Authorization: `Bearer ${token}` // Gửi token trong header Authorization
                }
            });
            
            // Lấy dữ liệu từ phản hồi
            const data = response.data; 
           // console.log(data); // Ghi ra dữ liệu trả về
        
            // Kiểm tra nếu có loan_id hoặc thông tin cần thiết khác từ data
            if (data && data.loan_id) {
                showNotification("Lưu thành công, mã HĐ: " + data.loan_id, "success");
            } else {
                showNotification("Dữ liệu không hợp lệ", "error");
            }
            
        } catch (error) {
            console.error("Error:", error); // Ghi lỗi ra console để kiểm tra
            showNotification("Lưu thất bại", "error");
        } finally {
            setLoadingItem(false);
        }
    };

    const dateFormat = 'DD/MM/YYYY'; // Define your desired date format

    const handleDateChange = (date) => {
        setFromDate(date); // Date will be a dayjs object
    };

    if (loadingFetch) {
        return (
            <div style={{ textAlign: 'center', marginTop: '50px' }}>
                <Spin size="large" /> {/* Bạn có thể thay đổi kích thước nếu cần */}
            </div>
        );
    }

    return (
        <div className="max-h-[80vh] overflow-y-auto">
            <h2 className="text-xl font-semibold mb-4">Cập nhật thông tin Hợp đồng</h2>
            <div className="border-t border-gray-300 pt-4">
                <div className="mb-6">
                    <h3 className="text-lg font-semibold mb-2 flex items-center">
                        <FaUser className="mr-2" />Thông tin khách hàng
                    </h3>
                    <div className="grid grid-cols-2 gap-4">
                        <div>
                            <label className="block text-sm font-medium mb-1">
                                Tên Khách hàng <span className="text-red-500">*</span>
                            </label>
                            <input
                                type="text"
                                className="w-full border border-gray-300 p-2 rounded"
                                placeholder="Nhập tên khách hàng"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium mb-1">
                                Mã hợp đồng <span className="text-red-500">*</span>
                            </label>
                            <input
                                type="text"
                                className="w-full border border-gray-300 p-2 rounded"
                                value={contractCode}
                                onChange={(e) => setContractCode(e.target.value)}
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium mb-1">Số CMND/Hộ chiếu</label>
                            <input
                                type="text"
                                className="w-full border border-gray-300 p-2 rounded"
                                placeholder="Nhập số CMND/Hộ chiếu"
                                value={numberCard}
                                onChange={(e) => setNumberCard(e.target.value)}
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium mb-1">Số điện thoại</label>
                            <input
                                type="text"
                                className="w-full border border-gray-300 p-2 rounded"
                                placeholder="Nhập số điện thoại"
                                value={phone}
                                onChange={(e) => setPhone(e.target.value)}
                            />
                        </div>
                        <div className="col-span-2">
                            <label className="block text-sm font-medium mb-1">Địa chỉ</label>
                            <textarea
                                className="w-full border border-gray-300 p-2 rounded"
                                placeholder="Nhập địa chỉ"
                                value={address}
                                onChange={(e) => setAddress(e.target.value)}
                            />
                        </div>
                    </div>
                </div>
                <div className="mb-6">
                    <h3 className="text-lg font-semibold mb-2 flex items-center">
                        <FaInfoCircle className="mr-2" />Thông tin khoản vay
                    </h3>
                    <div className="grid grid-cols-2 gap-4">
                        
                        <div>
                            <label className="block text-sm font-medium mb-1">
                                Tổng số tiền vay <span className="text-red-500">*</span>
                            </label>
                            <div className="relative">
                            <input
                                type="text"
                                className="w-full border border-gray-300 p-2 rounded"
                                value={totalMoney ? Number(totalMoney).toLocaleString('vi-VN') : ''}
                                onChange={handleChangeLocale}
                                onMouseLeave={handleMouseLeave}
                                disabled={isEdit}
                            />
                            {tooltip && (
                                <div className="absolute bg-gray-700 text-white p-2 rounded mt-1">
                                    {tooltip}
                                </div>
                            )}
                            </div>
                        </div>

                        <div>
                            <label className="block text-sm font-medium mb-1">Hình thức lãi</label>
                            <select
                                className="w-full border border-gray-300 p-2 rounded"
                                value={rateType}
                                onChange={(e) => setRateType(e.target.value)}
                            >
                                <option>Lãi ngày (k/triệu)</option>
                            </select>
                        </div>
                        {/* <div className="flex items-center">
                            <input
                                type="checkbox"
                                className="mr-2"
                                checked={prepaidrate}
                                onChange={(e) => setPrepaidrate(e.target.checked)}
                            />
                            <label className="text-sm font-medium">Thu lãi trước</label>
                        </div> */}
                        <div>
                            <label className="block text-sm font-medium mb-1">
                                Số ngày vay <span className="text-red-500">*</span>
                            </label>
                            <input
                                type="number"
                                className="w-full border border-gray-300 p-2 rounded"
                                placeholder="Nhập Số ngày vay"
                                value={loanTime}
                                onChange={(e) => setLoanTime(e.target.value)}
                                disabled={isEdit}
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium mb-1">
                                Kỳ lãi <span className="text-red-500">*</span>
                            </label>
                            <input
                                type="number"
                                className="w-full border border-gray-300 p-2 rounded"
                                placeholder="VD : 10 ngày đóng lãi 1 lần thì điền số 10"
                                value={frequency}
                                onChange={(e) => setFrequency(e.target.value)}
                                disabled={isEdit}
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium mb-1">
                                Lãi k/triệu <span className="text-red-500"> * </span>
                            </label>
                            <input
                                type="number"
                                className="w-full border border-gray-300 p-2 rounded"
                                placeholder="Nhập Số lãi"
                                value={rate}
                                onChange={(e) => setRate(e.target.value)}
                                disabled={isEdit}
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium mb-1">Ngày vay</label>
                            <DatePicker
                                value={fromDate ? dayjs(fromDate, 'DD-MM-YYYY') : null} // Ensure value is controlled
                                format={'DD/MM/YYYY'}
                                onChange={(date, dateString) => {
                                    setFromDate(dateString); // Update fromDate when a new date is picked
                                }}
                                disabled={isEdit}
                            />
                        </div>
                        <div className="col-span-2">
                            <label className="block text-sm font-medium mb-1">Ghi chú</label>
                            <textarea
                                className="w-full border border-gray-300 p-2 rounded"
                                placeholder="Nhập ghi chú"
                                value={note}
                                onChange={(e) => setNote(e.target.value)}
                            />
                        </div>
                        <div className="col-span-2">
                            <label className="block text-sm font-medium mb-1">NV thu tiền</label>
                            <input
                                type="text"
                                className="w-full border border-gray-300 p-2 rounded"
                                value={collectorName}
                                onChange={(e) => setCollectorName(e.target.value)}
                            />
                        </div>
                    </div>
                </div>
                <div className="flex flex-col items-center mt-4">
                    <button
                        className="bg-blue-500 text-white px-4 py-2 rounded flex items-center justify-center relative"
                        onClick={handleSubmit}
                    >
                        <FaSave className="mr-2" />
                        <span>Lưu lại</span>
                        {loadingItem && ( // Show Spin only when loading
                            <span className="ml-3">
                                <Spin indicator={whiteSpinnerIcon} />
                            </span>
                        )}
                    </button>
                </div>
                <p className="text-sm text-red-500 mt-4">
                    *Chú ý : Khách hàng phải đảm bảo lãi suất và chi phí khi cho vay (gọi chung là "chi phí vay")
                    tuân thủ quy định pháp luật tại từng thời điểm.
                </p>
            </div>
        </div>
    );
}
